import canvasTooltip from '@/shared/Charting/canvas-utils/canvas-tooltip'
import canvasGradients from '@/shared/Charting/canvas-utils/canvas-gradients'

const canvasUtils = {
  tooltip: canvasTooltip,
  gradients: canvasGradients,
}
export default canvasUtils
